// src/user/socialPopupFocus.js
//
// 2026-05-24 (REVERT) — This is now a transparent passthrough.
//
// This helper used to override window.open to recenter the OAuth popup
// and repeatedly call .focus() on it. On mobile Chrome that override
// (custom `popup=` / width / height features + a focus() interval)
// broke the popup -> opener handoff: after the user picked their
// Google / Apple account, the credential never made it back to the app
// tab, so the app never signed in and never navigated.
//
// The last known-good build (LEX_saas_08032025 copy 3) called
// signInWithPopup directly with NO wrapper, and mobile Chrome worked.
// We restore that behavior by making this a plain passthrough — the
// desktop popup just opens at the browser's default position, which is
// a fine tradeoff for a sign-in flow that actually completes on every
// device.
//
// Kept as an exported function (not deleted) because firebase.js and
// AuthContext.js still import it.
export async function withFocusedSocialPopup(runPopupAuth) {
  if (typeof runPopupAuth !== "function") {
    throw new Error("withFocusedSocialPopup requires a function.");
  }
  return runPopupAuth();
}
